import { connectedStore } from '../../store';
import selectors from '../selectors';

const getRenderStatus = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getRenderStatus(state);
};

export default getRenderStatus;
